/*
 * Каркас загрузки. Анимация и цвет плашки живут в base.css (.plnr-skeleton) —
 * там же, где их видит «проверяем доступ». Здесь только формы.
 */

.lines {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.circle {
  border-radius: 50%;
  flex: none;
}

.block {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
}
